<template>
  <v-container >
    <hr style="width: 50%; margin: 0 auto; color: #eeeeee; background-color: #eeeeee; border: 1px solid #efefef;">
    <!-- <br> -->
    <TC :show.sync="isShowTerm" @onClose= "onCloseTerm" />
    <FAQ :show.sync="isShowFAQ" @onClose= "onCloseFAQ" />
    <v-footer padless color="#ffffff" style="color: #585859; font-size: .9em; padding: 60px 0" >
      <v-container>
        <v-row>
          <v-col cols="12" lg="4" md="4" sm="12">
            <p>LIFE IS A JOURNEY.</p>
          </v-col>
          <v-col cols="12" lg="4" md="4" sm="12">
            <p :style="fontSize">{{text.getConnect}}</p>
            <p>
              <a href="https://www.facebook.com/AnantaraVacationClub/" target="_blank" class="pl-0 p-3"><i class="fab fa-facebook" style="color:#b3a358;font-size:16pt;"></i></a>
              <a href="https://twitter.com/anantaraclub" target="_blank" class="p-3"><i class="fab fa-twitter" style="color:#b3a358;font-size:16pt;"></i></a>
              <a href="https://www.instagram.com/anantaraclub" target="_blank" class="p-3"><i class="fab fa-instagram" style="color:#b3a358;font-size:16pt;"></i></a>
              <a href="http://www.weibo.com/anantaraclub" target="_blank" class="p-3"><i class="fab fa-weibo" style="color:#b3a358;font-size:16pt;"></i></a>
              <a href="https://www.youtube.com/user/AnantaraEscapes" target="_blank" class="p-3"><i class="fab fa-youtube" style="color:#b3a358;font-size:16pt;"></i></a>
              <a href="http://weixin.qq.com/r/O3V1baXE9-ilreEO9yAp" target="_blank" class="p-3"><i class="fab fa-weixin" style="color:#b3a358;font-size:16pt;"></i></a>
            </p>
          </v-col>
          <v-col cols="12" lg="4" md="4" sm="12">
            <p :style="fontSize">{{text.contactOur}}</p>
            <p>
              <a href="mailto:info@anantaraclub.com" class="link">info@anantaraclub.com</a>
            </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <span>&copy;</span> 2020 By
          <a
            href="https://www.anantaravacationclub.com"
            target="_blank"
            class="link"
          >Anantara Vacation Club</a> | 
          
          <span :style="fontSize">
            <a @click.stop="showTerm" class="link">{{text.terms}}</a> |
            <a @click.stop="showFAQ" class="link">{{text.faq}}</a>
            | <a :href="text.linkBooklet" target="_blank" class="link">{{text.booklet}}</a>
          </span>
          </v-col>
        </v-row>
        
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import TC from "@/components/TermsAndConditions.vue";
import FAQ from "@/components/FAQ.vue";
export default {
  name: "Footer",
  components: {
    TC, FAQ
  },
  data() {
    return {
      lang: this.$route.params.lang,
      isShowTerm: false,
      isShowFAQ: false,
      text: {
        terms: '',
        faq: '',
        booklet: '',
        linkBooklet: '',
        getConnect: '',
        contactOur: ''
      },
      fontSize: {}
    };
  },
  methods: {
    showTerm() {
      this.isShowTerm = true;
    },
    showFAQ() {
      this.isShowFAQ = true;
    },
    onCloseTerm() {
      this.isShowTerm = false;
    },
    onCloseFAQ() {
      this.isShowFAQ = false;
    },
    loadData() {
      if(this.lang == 'en') {
        this.text = {
          terms: 'Terms and Conditions',
          faq: 'FAQ',
          booklet: 'Booklet',
          linkBooklet: '/data/booket-v1.pdf',
          getConnect: 'GET CONNECTED',
          contactOur: 'CONTACT OUR TEAM'
        }
      }
      else if(this.lang == 'cn') {
        this.text = {
          terms: '条款与细则',
          faq: '常见问题 ',
          booklet: 'Booklet',
          linkBooklet: '/data/booklet-v1-cn.pdf',
          getConnect: '社交平台',
          contactOur: '与我们的团队联系'
        }
      }
      else if(this.lang == 'th') {
        this.fontSize = {"font-size": "20px", "font-family": "\"Browallia New\", sans-serif"};
        this.text = {
          terms: 'เงื่อนไขและข้อกำหนด ',
          faq: 'คำถามที่พบบ่อย ',
          booklet: 'คู่มือโปรแกรม',
          linkBooklet: '/data/booklet-v1-th.pdf',
          getConnect: 'ติดตามเรา',
          contactOur: 'ติดต่อเรา'
        }
      }

    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped>
  .p-3 {
    padding: 1rem;
  }
  .link {
    color: #b3a258;
    text-decoration: none;
  }
</style>